module.exports = __webpack_public_path__ + "media/images/icon_close-circle-b9318970919371c79e0fffc17bf8743a.svg";